/**
 * heroHeight function
 * 
 * On tablet devices set hero hight to be same as hero width.
 * If hero height was changed and window width is now less then 768px or greater then 1199, set height per design.
 *
 */

function HeroHeight() {

  // set up properties
  const hero = document.querySelector('.hero');
  let heightChanged = false;
  
  
    const changeHeight = () => {

      // check if hero exists
      if(hero) {
        // set up properties
        const heroWidth = hero.offsetWidth;
        const windowWidth = window.innerWidth;

        if(windowWidth >= 768 && windowWidth < 1200) {
          // limit hero height change to device view height
          if( window.innerHeight >= heroWidth ) {
            hero.style.height = `${heroWidth}px`;
            heightChanged = true;
          }
        } else if( heightChanged ) {
          if(windowWidth < 768) {
            hero.style.height = 'calc(100vh - 12px)';
            heightChanged = false;
          } else if(windowWidth >= 1200) {
            hero.style.height = 'calc(100vh - 40px)';
            heightChanged = false;
          }
        } else {
          return;
        }
      }
      else {
        return;
      }
    }

    return {
      changeHeight
    }
}

export default HeroHeight;